import { AppState, updateModalStateAction } from "@store";
import * as cn from "classnames";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import "./ModalWindow.css";

interface ModalWindowProps {
    modalId: string;
    modal?: boolean | undefined;
    updateModalState?: (modalId: string, newState: boolean) => void;
    state?: boolean;
    className?: string;
    children: React.ReactChild | React.ReactChild[];
    transition?: { fadeInClassName?: string; fadeOutClassName?: string } | boolean;
}

type TransitionType = "fadeIn" | "fadeOut";

class ModalWindowComponent extends React.Component<ModalWindowProps, any> {
    private parent = React.createRef<HTMLDivElement>();
    private onFadeInClass = "ModalWindow-fadeIn";
    private onFadeOutClass = "ModalWindow-fadeOut";
    constructor(props: ModalWindowProps) {
        super(props);
        this.state = { animateClass: "" };
        if (props.transition && typeof props.transition == "object") {
            this.onFadeInClass = props.transition.fadeInClassName || this.onFadeInClass;
            this.onFadeOutClass = props.transition.fadeOutClassName || this.onFadeOutClass;
        }
    }
    renderModal = () => {
        const { updateModalState, modalId } = this.props;
        updateModalState(modalId, true);
    };
    disableModal = () => {
        const { updateModalState, modalId } = this.props;
        updateModalState(modalId, false);
    };
    callAfterTransition(func: any, transitionType: TransitionType) {
        return () => {
            this.animate(transitionType).then(() => func());
        };
    }
    bindDebounceIfNeeded() {
        const { transition } = this.props;
        if (transition) {
            this.disableModal = this.callAfterTransition(this.disableModal, "fadeOut");
        }
    }
    animate(type: "fadeIn" | "fadeOut") {
        return new Promise((resolve, reject) => {
            let className = "";
            switch (type) {
                case "fadeIn":
                    className = this.onFadeInClass;
                    break;
                case "fadeOut":
                    className = this.onFadeOutClass;
                    break;
            }
            this.setState({ animateClass: className }, () => {
                this.parent.current.addEventListener("transitionend", () => resolve());
            });
        });
    }
    componentDidUpdate(prevProps: any) {
        const { state, updateModalState, modalId } = this.props;
        if (this.props.transition) {
            if (prevProps.modal != this.props.modal && this.props.modal) {
                this.animate("fadeIn");
            }
        }
        if (prevProps.state != this.props.state) {
            updateModalState(modalId, state);
        }
    }
    componentDidMount() {
        const { state } = this.props;
        this.bindDebounceIfNeeded();
        if (state) this.renderModal();
    }
    render() {
        const { modal, modalId, className, transition } = this.props;
        if (!modal) return null; // Remove modal from DOM
        return (
            // React clone element
            <div
                className={cn(
                    "ModalWindow",
                    className,
                    transition && typeof transition == "boolean" ? "ModalWindow-withTransitions" : "",
                    transition ? this.state.animateClass : ""
                )}
                ref={this.parent}
            >
                <div className="ModalWindow__content">
                    {React.Children.map(this.props.children, (child: any) => {
                        return React.cloneElement(child, {
                            renderModal: this.renderModal,
                            disableModal: this.disableModal,
                            modalId
                        });
                    })}
                </div>
            </div>
        );
    }
}

export const ModalWindow = connect<any>(
    (state: AppState, ownProps: ModalWindowProps) => {
        return { modal: state.modal[ownProps.modalId] };
    },
    (dispatch: Dispatch) => ({
        updateModalState: (modalId: string, newState: boolean) =>
            dispatch(updateModalStateAction({ modalId, newState }))
    })
)(ModalWindowComponent);
